export enum ContractTypes {
    PREVENTION = 'prevention',
    VEHICLE = 'vehicle',
    LIABILITY = 'liability',
    BUILDING = 'building',
    TRAVEL_INSURANCE = 'travelInsurance',
}
